import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  formLabelsTheme,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchGroupCountry,
  fetchGroupPhoneType,
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalOffice } from "../filterModal/ModalOffice";
import { ModalClient } from "../filterModal/ModalClient";

import {
  editParty,
  fetchIdParty,
  selectIdParty,
  selectLoading,
} from "./partySlice";
import { ModalAddress } from "./ModalAddrees";
import {
  fetchCountryAll,
  fetchMstaddresstype,
  selectMstaddresstype,
} from "../location/locationSlice";
import { fetchClient } from "../client/clientSlice";
import { v4 as uuidv4 } from "uuid";
import { PartyDuplicate } from "./PartyDuplicate";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const PartyEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdParty);
  const dataClientRelated = useSelector(selectParameter);
  const dataCarier = useSelector(selectParameter2);
  const dataAddress = useSelector(selectMstaddresstype);
  const { id } = useParams();

  const [listOffice, setListOffice] = useState([]);
  const [listClient, setListClient] = useState([]);
  const [listAddress, setListAddress] = useState([]);
  const [clientRelated, setClientRelated] = useState([]);
  const [carier, setCarier] = useState([]);
  const [rowIndex, setRowIndex] = useState(null);
  const [formatExtraData, setFormatExtraData] = useState([]);
  const [dataRow, setDataRow] = useState(null);
  // initial

  const [formValues, setFormValues] = useState({
    party_code: {
      value: "",
      error: false,
      required: "Y",
    },
    party_name: {
      value: "",
      error: false,
      required: "Y",
    },
    party_description: {
      value: "",
      error: false,
      required: "N",
    },
    party_rating: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(
        fetchParameter({
          paramgroup_code: "CLIENT_RELATED",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "CARRIER",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(fetchIdParty(id));

      await dispatch(
        fetchMstaddresstype({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );

      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(fetchGroupPhoneType("PHONETYPE"));
      await dispatch(
        fetchOffice({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        party_code: {
          value: dataId.party_code,
          error: false,
          required: "Y",
        },
        party_name: {
          value: dataId.party_name,
          error: false,
          required: "Y",
        },
        party_description: {
          value: dataId.party_description,
          error: false,
          required: "N",
        },
        party_rating: {
          value: dataId.party_rating,
          error: false,
          required: "N",
        },
      });
      setListClient(dataId.clients === null ? [] : dataId.clients);
      setListOffice(dataId.offices === null ? [] : dataId.offices);
      setListAddress(
        dataId.addresses === null
          ? []
          : dataId.addresses.map((item, index) => {
              return {
                ...item,
                uuid: uuidv4(),
              };
            })
      );

      // const initData = dataId.addresses.map((item, index) => {
      //   return {
      //     ...item,
      //     uuid: uuidv4(),
      //   };
      // });

      const newData =
        dataId.clientrelated === null
          ? dataClientRelated.map((item) => {
              return {
                ...item,
                checked: false,
              };
            })
          : dataClientRelated.map((item) => {
              const match = dataId.clientrelated.find(
                (d) => d.clientrelated_code === item.param_code
              );
              if (match) {
                return { ...item, checked: true };
              }
              return item;
            });

      setClientRelated(newData);

      const newData2 =
        dataId.carrier === null
          ? dataCarier.map((item) => {
              return {
                ...item,
                checked: false,
              };
            })
          : dataCarier.map((item) => {
              const match = dataId.carrier.find(
                (d) => d.carrier_code === item.param_code
              );
              if (match) {
                return { ...item, checked: true };
              }
              return item;
            });

      setCarier(newData2);
    }
  }, [dataId]);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const filteredClient = clientRelated.filter(
      (item) => item.checked === true
    );

    const listRelated = filteredClient.map((item) => {
      return {
        clientrelated_code: item.param_code,
      };
    });
    const filteredCarier = carier.filter((item) => item.checked === true);
    const listCarier = filteredCarier.map((item) => {
      return {
        carrier_code: item.param_code,
      };
    });

    const params = {
      party_id: id,
      party_code: formValues.party_code.value,
      party_name: formValues.party_name.value,
      party_description: formValues.party_description.value,
      party_rating: formValues.party_rating.value,
      clientrelated: listRelated,
      carrier: listCarier,
      offices: listOffice,
      clients: listClient,
      addresses: listAddress,
    };
    try {
      const response = await dispatch(editParty(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={(e) => handleDelete(e, row, rowIndex, formatExtraData)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const actionFormatterAddress = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Edit</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={(e) => {
              setDataRow(row);
              setRowIndex(rowIndex);
              setFormatExtraData(formatExtraData);
              setShowAddress(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
            </span>
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
            onClick={(e) =>
              handleDeleteAddress(e, row, rowIndex, formatExtraData)
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columns = [
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      formatExtraData: listOffice,
    },
  ];

  const actionFormatterClient = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) =>
              handleDeleteClient(e, row, rowIndex, formatExtraData)
            }
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsClient = [
    {
      text: "Client Code",
      dataField: "client_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Client Name",
      dataField: "client_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterClient,
      align: "center",
      headerAlign: "center",
      formatExtraData: listClient,
    },
  ];

  const columnsAddress = [
    {
      text: "Address",
      dataField: "address1",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterAddress,
      align: "center",
      headerAlign: "center",
      formatExtraData: listAddress,
    },
  ];

  const handleDelete = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.office_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.office_id !== idColumn);
    setListOffice(items);
  };

  const handleDeleteClient = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.client_id;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.client_id !== idColumn);
    setListClient(items);
  };

  const handleDeleteAddress = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.uuid;
    const temp = [...formatExtraData];
    let items = temp.filter((value, index) => value.uuid !== idColumn);
    setListAddress(items);
  };

  // modal office

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // modal Client

  const [showClient, setShowClient] = useState(false);
  const handleCloseClient = () => setShowClient(false);
  const handleShowClient = () => setShowClient(true);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleTypeClient = (clientrelated_code) => {
    const newData = clientRelated.map((item) => {
      if (item.param_code === clientrelated_code) {
        return { ...item, checked: true };
      }
      return item;
    });

    setClientRelated(newData);
  };

  const handleTypeClientRemove = (clientrelated_code) => {
    const newData = clientRelated.map((item) => {
      if (item.param_code === clientrelated_code) {
        return { ...item, checked: false };
      }
      return item;
    });

    setClientRelated(newData);
  };

  const handleCarrier = (carrier_code) => {
    const newData = carier.map((item) => {
      if (item.param_code === carrier_code) {
        return { ...item, checked: true };
      }
      return item;
    });

    setCarier(newData);
  };

  const handleCarrierRemove = (carrier_code) => {
    const newData = carier.map((item) => {
      if (item.param_code === carrier_code) {
        return { ...item, checked: false };
      }
      return item;
    });

    setCarier(newData);
  };

  // modal Address

  const [showAddress, setShowAddress] = useState(false);

  const handleCloseAddress = () => setShowAddress(false);
  const handleShowAddress = () => setShowAddress(true);

  const [showDuplicate, setShowDuplicate] = useState(false);

  const [formDuplicate, setFormDuplicate] = useState({
    party_code: {
      value: "",
      error: false,
      required: "Y",
    },
    party_name: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              Edit Party Master : {dataId.party_code}
            </CardHeaderTitle>

            <CardHeaderToolbar>
              <Button
                className="primary"
                onClick={() => history.push(`/master/party-master`)}
              >
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              <>
                <div>
                  <Row>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        required
                        label="Code"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="party_code"
                        value={formValues.party_code.value}
                        onChange={handleChange}
                        error={formValues.party_code.error}
                        helperText={
                          formValues.party_code.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                      <RedditTextField
                        required
                        label="Name"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="party_name"
                        value={formValues.party_name.value}
                        onChange={handleChange}
                        error={formValues.party_name.error}
                        helperText={
                          formValues.party_name.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        label="Rating"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="party_rating"
                        onChange={handleChange}
                        value={formValues.party_rating.value}
                      />
                      <RedditTextField
                        label="Description"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="party_description"
                        onChange={handleChange}
                        value={formValues.party_description.value}
                      />
                    </Col>
                  </Row>
                </div>
                <hr />
                {/*Party Settings */}

                <div>
                  <p className="font-weight-boldest">Party Settings </p>
                  <CardBody>
                    <div>
                      <p className="font-weight-boldest">Client Related</p>
                      <Col xs={12} sm={3} md={8} lg={8}>
                        <Row>
                          {clientRelated.map((item, index) => {
                            return (
                              <Col md={3}>
                                <Form.Check
                                  label={item.param_value}
                                  value={item.param_code}
                                  name="group1"
                                  type="checkbox"
                                  className="mr-8 mb-4"
                                  checked={item.checked === true ? true : false}
                                  onChange={(e) => {
                                    if (e.target.checked === true) {
                                      handleTypeClient(item.param_code);
                                    } else {
                                      handleTypeClientRemove(item.param_code);
                                    }
                                  }}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </Col>
                    </div>
                    <div>
                      <p className="font-weight-boldest">Carrier</p>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          {carier.map((item, index) => {
                            return (
                              <Col md={4}>
                                <Form.Check
                                  label={item.param_value}
                                  value={item.param_code}
                                  name="group1"
                                  type="checkbox"
                                  className="mr-8 mb-4"
                                  checked={item.checked === true ? true : false}
                                  onChange={(e) => {
                                    if (e.target.checked === true) {
                                      handleCarrier(item.param_code);
                                    } else {
                                      handleCarrierRemove(item.param_code);
                                    }
                                  }}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </Col>
                    </div>
                  </CardBody>
                </div>
                <hr />

                <hr />
                {/* Template File */}
                <div>
                  <p className="font-weight-boldest">
                    Address & Contact Details
                  </p>

                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                    bootstrap4
                    
                    keyField="uuid"
                    data={listAddress}
                    columns={columnsAddress}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                  <Row className="mt-6 justify-content-end">
                    <Button
                      variant="outline-primary"
                      onClick={handleShowAddress}
                    >
                      Add Address
                    </Button>
                  </Row>
                </div>

                <hr />
                {/* Office */}
                <div>
                  <h5 className="text-bold">Associated Offices</h5>

                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                    bootstrap4
                    
                    keyField="No"
                    data={listOffice}
                    columns={columns}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />

                  <Row className="mt-6 justify-content-end">
                    <Button variant="outline-primary" onClick={handleShow}>
                      Add Office
                    </Button>
                  </Row>
                </div>
                <hr />
                {/* Client */}
                <div>
                  <h5 className="text-bold">Associated Clients</h5>

                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                    bootstrap4
                    
                    keyField="client_id"
                    data={listClient}
                    columns={columnsClient}
                    hover
                    striped
                    headerClasses="header-class"
                  />

                  <Row className="mt-6 justify-content-end">
                    <Button
                      variant="outline-primary"
                      onClick={handleShowClient}
                    >
                      Add Client
                    </Button>
                  </Row>
                </div>
                <hr />

                {/* handleSave */}
                <Row className="mt-6 justify-content-end">
                  <Button
                    className="btn btn-primary my-btn-primary-dark text-bold mr-5"
                    onClick={(e) => setShowDuplicate(true)}
                  >
                    Duplicate
                  </Button>
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Row>
              </>
            </ThemeProvider>
          </CardBody>
        </Card>

        <ModalOffice
          isOpen={show}
          handleClose={handleClose}
          handleShow={handleShow}
          setListOffice={setListOffice}
          listOffice={listOffice}
        />

        <ModalClient
          isOpen={showClient}
          handleClose={handleCloseClient}
          handleShow={handleShowClient}
          setListClient={setListClient}
          listClient={listClient}
        />

        <ModalAddress
          isOpen={showAddress}
          handleClose={handleCloseAddress}
          handleShow={handleShowAddress}
          setShowAddress={setShowAddress}
          listAddress={listAddress}
          setListAddress={setListAddress}
          dataRow={dataRow}
          setDataRow={setDataRow}
          formatExtraData={formatExtraData}
          setFormatExtraData={setFormatExtraData}
          rowIndex={rowIndex}
          setRowIndex={setRowIndex}
        />
        <PartyDuplicate
          id={id}
          isOpen={showDuplicate}
          setShow={setShowDuplicate}
          setFormValues={setFormDuplicate}
          formValues={formDuplicate}
        />
      </>
    )
  );
};
